module.exports = __webpack_public_path__ + "static/schaukel05-0c33771cbd363880b45cc59e9e5c4adf.jpg";